const REPORT_NAMES = {
  CandidateCampaignExamAttendance: "CandidateCampaignExamAttendance",
  CandidateCampaignExamResults: "CandidateCampaignExamResults",
  CandidateCampaignAllExamsResults: "CandidateCampaignAllExamsResults",
  CandidateCampaignExamsRoomCapacities: "CandidateCampaignExamsRoomCapacities",
  CandidateInfoLog: "CandidateInfoLog",
  CandidateCampaignExamStatistic: "CandidateCampaignExamStatistic",
  RegularCampaignCandidates: "RegularCampaignCandidates",
  PaidCampaignCandidates: "PaidCampaignCandidates",
  ForeignerCampaignCandidates: "ForeignerCampaignCandidates",
  CoursesCampaignCandidates: "CoursesCampaignCandidates",
  CandidatesNotAccessedProfile: "CandidatesNotAccessedProfile",
  SuccessfulPayments: "SuccessfulPayments",
  OnlineSales: "OnlineSales",
  AllStudentsAcademicData: "AllStudentsAcademicData",
  GradeDistributionByCourse: "GradeDistributionByCourse",
  StudentAverageGradeBySemesters: "StudentAverageGradeBySemesters",
  StudentAverageGradeByCourses: "StudentAverageGradeByCourses",
  LeftQuitDismissedStudents: "LeftQuitDismissedStudents",
  GraduatedStudents: "GraduatedStudents",
  GradeDistributionSummary: "GradeDistributionSummary",
  StudentsByCourseAndGroup: "StudentsByCourseAndGroup",
  ExtendedStudentsByCourseAndGroup: "ExtendedStudentsByCourseAndGroup",
  StudentAverageSuccess: "StudentAverageSuccess",
  StudentsByStatusAndCourse: "StudentsByStatusAndCourse",
  UnpaidSemesterFees: "UnpaidSemesterFees",
  BirthYearDistributionByCourse: "BirthYearDistributionByCourse",
  GenderDistributionByCourse: "GenderDistributionByCourse",
  BirthCountryDistributionByCourse: "BirthCountryDistributionByCourse",
  StudentEnrollmentYear: "StudentEnrollmentYear",
  StudentGraduationYear: "StudentGraduationYear",
  GetStudentsSemesterFees: "GetStudentsSemesterFees",
  SessionExamSchedule: "SessionExamSchedule",
  StateExamSchedule: "StateExamSchedule",
  StudentsWithoutDisciplineAttestation: "StudentsWithoutDisciplineAttestation",
  DentalDisciplinesAverageGrades: "DentalDisciplinesAverageGrades",
  DentalDisciplinesSessionExamsDetail: "DentalDisciplinesSessionExamsDetail",
  SessionStartUnpassedExamsCount: "SessionStartUnpassedExamsCount",
  SessionFinalResult: "SessionFinalResult",
  UnpassedExams: "UnpassedExams",
  SessionStartAnalysis: "SessionStartAnalysis",
  ScholarshipAverageGrade: "ScholarshipAverageGrade",
  StudentsByZvo: "StudentsByZvo",
  DisciplineSessionExamSuccessRate: "DisciplineSessionExamSuccessRate",
  InterruptedStudentsWithUnpassedExams: "InterruptedStudentsWithUnpassedExams",
  StudentsCandidateScore: "StudentsCandidateScore",
  StudentsBirthPlace: "StudentsBirthPlace",
  SummaryOfStudentCountsByStatus: "SummaryOfStudentCountsByStatus",
  StudentsWithUnpassedExams: "StudentsWithUnpassedExams",
  StudentsPermanentAddress: "StudentsPermanentAddress",
  HealthInsurance: "HealthInsurance",
};

const REPORT_CATEGORIES = {
  CandidateCampaigns: 0,
  Financial: 1,
  Academic: 2,
  Student: 3,
};

const FILE_EXTENSIONS = {
  Excel: "xlsx",
  Xml: "xml",
  Txt: "txt",
};

export { REPORT_NAMES, REPORT_CATEGORIES, FILE_EXTENSIONS };
